import React,{useEffect} from 'react'
import login from '../../img/login-check.gif'
import {useHistory} from 'react-router-dom'

//muestra el pedido en curso o en caso de error mostrara un mensaje por si lo emails no coincide
function Order({show,status, orderId, clearItems, message}) {
    let history = useHistory()

    useEffect(() => {
      if(orderId){

        clearItems()
      }
      
    }, [orderId])

    function routeChange(){
      history.push('/')
    }
    return (

      <div className="modal fade" id="Order" data-backdrop="static" data-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">ULTIMO PASO...!</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div className="modal-body">

                {show ? <><h3>{status}</h3> {orderId && <p>Este es su seguimiento N°: {orderId}</p>}</> :  message ? <p className="email-err">{message}</p> : <img className="img-order" src={login} alt="loader"/> }
              </div>  
              <div className="modal-footer">

                {message ? 

                <button type="button" className="btn cart" data-toggle="modal" data-target="#staticBackdrop" data-dismiss="modal" >Volver</button> 
                
                :
                  
                <button type="button" className="btn cart" data-dismiss="modal" disabled={!show} onClick={()=>routeChange()}>Cerrar</button>}
                
              </div>
            </div>
          </div>
      </div>
  )    
}
export default Order;